var _path, _path2, _path3, _circle, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 14.4V3.59998C10.1 2.49541 9.20462 1.59998 8.10005 1.59998H3.30005C2.19548 1.59998 1.30005 2.49541 1.30005 3.59998V14.4",
    stroke: "#BCBAAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90002 4.19995C2.90002 3.64767 3.34774 3.19995 3.90002 3.19995H7.50003C8.05231 3.19995 8.50002 3.64767 8.50002 4.19995V6.19995C8.50002 6.75224 8.05231 7.19995 7.50002 7.19995H3.90002C3.34774 7.19995 2.90002 6.75224 2.90002 6.19995V4.19995Z",
    stroke: "#BCBAAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 8.4C12.5 8.4 12.1 9.76 12.1 10.4C12.1 11.04 12.1 12 12.1 12C12.1 12 12.1 13.6 13.9 13.6C15.7 13.6 15.7 12 15.7 12V7.2M15.3 5.2L12.9 2",
    stroke: "#BCBAAC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8999,
    cy: 6.40005,
    r: 1.1,
    stroke: "#BCBAAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.7999H16.5",
    stroke: "#BCBAAC",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.2938281524dd0d6616b4896e5110caef.svg";
export { ForwardRef as ReactComponent };